import { makeStyles, type Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  modalBtnClose: {
    color: "#0344DC",
    border: "none",
    padding: "8px 24px",
    fontFamily: "Inter",
    "&:hover": {
      backgroundColor: "#F1F5FF",
      border: "none",
      color: "#0344DC",
    },
  },
  lessonCollectibleContainer: {
    padding: "10px",
    width: "100%",
  },
  lessonCollectibleItem: {
    cursor: "pointer",
  },
  imageContainer: {
    position: "relative",
    width: "330px",
    height: "168px",
    flexGrow: 1,
    overflow: "hidden",
    marginBottom: "20px",
  },
  img: {
    position: "absolute",
    width: "100%",
    height: "100%",
    verticalAlign: "middle",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    objectFit: "cover",
    borderRadius: "10px",
  },
  iconTypeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#45547C",
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      fontFamily: "lato",
    },
  },
  icon: {
    fill: "#45547C",
    marginRight: "5px",
  },
  textContainer: {
    marginTop: "7px",
    width: "100%",
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "lato",
    fontWeight: 600,
    color: "#0F172A",
    overflow: "hidden",
  },
  dialog: {
    "& .MuiDialogActions-root": {
      display: "flex",
      alignItem: "center",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    "& .MuiDialogTitle-root": {
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
  },
  bigModal: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "60%",
    },
  },
  dialogTitle: {
    maxWidth: "80%",
    "& .MuiTypography-root": {
      color: "black",
      padding: "12px 0",
      fontSize: theme.typography.pxToRem(20),
      fontFamily: "Lato",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px !important",
      alignSelf: "center",
    },
  },
  dialogActions: {
    padding: "10px 0",
    margin: "18px 0",
    justifyContent: "flex-end!important",
    "& .MuiButtonBase-root": {
      borderRadius: "100px!important",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
    },
  },
}));
